import styled from 'styled-components';
import { ReactComponent as Slack } from '@elementary/common-ui/assets/select-slack.svg';
import { ReactComponent as Teams } from '@elementary/common-ui/assets/select-teams.svg';
import { Button, Flex } from '@elementary/common-ui/components';
import { MessagingIntegration } from 'shared/types';
import IntegrationDialog from '../../shared/Integration/IntegrationDialog';

const ProviderButton = styled(Button).attrs(() => ({
  variant: 'outlined',
}))`
  height: 120px;
  padding: 24px;
  flex: 1 0 0;
`;

const IntegrationSelection = ({
  open,
  onClose,
  onSelected,
}: {
  open: boolean;
  onClose: () => void;
  onSelected: (messagingIntegration: MessagingIntegration) => void;
}) => (
  <IntegrationDialog
    open={open}
    onClose={onClose}
    title="Connect your messaging tool"
    hideSaveButton
    width={720}
  >
    <Flex gap={3}>
      <ProviderButton onClick={() => onSelected('Slack')}>
        <Slack />
      </ProviderButton>
      <ProviderButton onClick={() => onSelected('Teams')}>
        <Teams />
      </ProviderButton>
    </Flex>
  </IntegrationDialog>
);

export default IntegrationSelection;
